import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { POSProvider } from './context/POSContext'
import store from './store'
import { Provider } from 'react-redux'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
    <POSProvider>
      <App />
    </POSProvider>
    </Provider>
  </StrictMode>,
)
